import type { TAddress } from "./address";
import type { TContact } from "./contact";
import type { TPartnerLite } from "./partner";

export const ProfileType = {
  Student: "Student",
  Guardian: "Guardian",
} as const;

export type TProfile = {
  contactId: string;
  uuid: string;
  address: TAddress;
  age: string;
  dob?: string;
  email: string;
  firstName: string;
  lastName: string;
  partner: TPartnerLite;
  phone?: string;
  relatedStudents?: Array<TContact<TProfile>>; //added clientside
  type: (typeof ProfileType)[keyof typeof ProfileType];
};

export type TFirstTimeUser = {
  contactId: string;
  email: string;
  type?: undefined;
  dob?: undefined;
  relatedStudents?: undefined;
  firstName?: undefined;
  lastName?: undefined;
};
